import React from 'react';
import { Link } from 'react-router-dom';

export default function Button({
  children,
  to,
  href,
  variant = 'secondary', // 'primary' | 'secondary' | 'whatsapp' | 'danger' | 'ghost'
  size = 'md', // 'sm' | 'md' | 'lg'
  fullWidth = false,
  className = '',
  disabled = false,
  onClick,
  ...props
}) {
  // Micro-interactions selon le skill Motion Design (3 couches: échelle primaire, élévation d'ombre secondaire, réponse sous 120ms)
  const baseStyles = "inline-flex items-center justify-center font-bold rounded-full transition-all duration-200 ease-[cubic-bezier(0.2,0,0,1)] hover:-translate-y-0.5 active:translate-y-0 active:scale-[0.97] disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none";

  const sizeStyles = {
    sm: "px-3.5 py-1.5 text-xs gap-1.5",
    md: "px-6 py-2.5 text-sm gap-2",
    lg: "px-8 py-3.5 text-base gap-2.5 shadow-acem-sm",
  };

  const variantStyles = {
    primary: "bg-acem-primary hover:bg-acem-primary-dark text-white shadow-acem-sm hover:shadow-acem-md active:shadow-sm",
    secondary: "bg-acem-surface-container hover:bg-acem-surface-container-high text-acem-text border border-acem-border hover:border-acem-primary/40",
    whatsapp: "bg-[#25D366] hover:bg-[#20ba59] text-white shadow-sm hover:shadow-md",
    danger: "bg-red-600 hover:bg-red-700 text-white shadow-sm hover:shadow-md",
    ghost: "bg-transparent hover:bg-acem-surface-container-low text-acem-primary",
  };

  const combinedClasses = `${baseStyles} ${sizeStyles[size] || sizeStyles.md} ${variantStyles[variant] || variantStyles.secondary} ${fullWidth ? 'w-full' : ''} ${className}`;

  if (to) {
    return (
      <Link to={to} className={combinedClasses} onClick={onClick} {...props}>
        {children}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={combinedClasses} onClick={onClick} target={props.target || "_self"} rel={props.rel || "noreferrer"} {...props}>
        {children}
      </a>
    );
  }

  return (
    <button
      type={props.type || "button"}
      className={combinedClasses}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}
